import PropTypes from "prop-types";
import pageStyles from "@/css/PageContent.module.css";

const BorderDiv = (props) => {
  let styles = { ...props.style };

  if (props.width) {
    styles.width = props.width;
    styles.minWidth = props.width;
    styles.msxWidth = props.width;
  }

  if (props.height) {
    styles.height = props.height;
    styles.minHeight = props.height;
    styles.maxHeight = props.height;
  }
  return (
    <div
      className={`${pageStyles.borderDiv}`}
      style={{ ...styles, ...(props.clearBorder && { border: "none" }) }}
    >
      {props.children}
    </div>
  );
};

BorderDiv.defaultProps = {
  clearBorder: false,
};

BorderDiv.propTypes = {
  height: PropTypes.object,
  width: PropTypes.object,
  children: PropTypes.node,
  clearBorder: PropTypes.bool,
};

export default BorderDiv;
